import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import type { SearchInputProps, SearchInputModelResponse } from './search-input.types'

export const useSearchInputModel = ({
  onSearch,
  onKeyDown,
  placeholder: propPlaceholder,
}: SearchInputProps): SearchInputModelResponse => {
  const t = useTranslate()

  const placeholder = propPlaceholder ?? t(TOLGEE_GLOBALS.search)

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && onSearch) {
      const value = (event.target as HTMLInputElement).value
      onSearch(value)
    }
    if (onKeyDown) {
      onKeyDown(event)
    }
  }

  return {
    placeholder,
    onKeyDown: handleKeyDown,
  }
}
